export default class Gotop {
    constructor() {
        this.$goTop = $('#go-top')
        this.$shareBox = $('#share')
        this.$goTop.on("click", function () {
            // 根據頁面高度和當前視口高度確定返回頂部所需時間，最小為 400
            var time = Math.max($("html, body").scrollTop() / ($(document).height() - $(window).height()), 0.4) * 1000
            $("html, body").animate({
                scrollTop: 0
            }, time)
        })

        // 侧边栏分享智能隐藏
        this._headroom('#go-top')

        // 顶部下载按钮智能隐藏
        this._headroom('#top-bar')

        //滚动高度超过 1.4屏幕高度时显示 按钮
        this.scrollScreenHeight()
    }
    _headroom(selector) {
        let ele = document.querySelector(selector)
        new Headroom(ele).init()
    }

    scrollScreenHeight() {
        $(window).on("scroll", () => {
            let winH = window.innerHeight
            let scrollH = $(window).scrollTop()
            if (winH * 1.2 < scrollH) {
                this.$goTop.fadeIn()
                this.$shareBox.fadeIn()
            } else {
                this.$goTop.fadeOut()
                this.$shareBox.fadeOut()
            }
        })
    }
}